import { useAuth } from "@/app/auth";
import { useOnline } from "@/app/online";
import { rememberedSecret, useReloginDeferred } from "@/app/relogin";
import { useVault } from "@/app/vault";
import { LockKeyhole } from "lucide-react";
import { useState } from "react";

export const SESSION_NOTICE_TEXT =
  "Estás trabajando sin sesión. Lo que ya cargaste queda guardado en el teléfono y sale cuando retomes la sesión. Para elegir la máquina, y por lo tanto para completar una carga nueva, primero tenés que retomar la sesión.";

export function SessionNotice() {
  const deferred = useReloginDeferred();
  const online = useOnline();
  const { resumeSession } = useAuth();
  const { status } = useVault();
  const silent = rememberedSecret() !== null;
  const [busy, setBusy] = useState(false);

  if (!deferred) {
    return null;
  }

  return (
    <section className="notice notice--offline session-notice">
      <LockKeyhole size={16} aria-hidden="true" />
      <div className="session-notice__body">
        <p className="t-small">{SESSION_NOTICE_TEXT}</p>
        {status.saved || silent ? null : (
          <p className="t-small">
            En este teléfono no hay PIN guardado, así que para retomar vas a tener que escribir tu
            usuario y tu contraseña.
          </p>
        )}
        {online ? null : (
          <p className="t-small">Retomar la sesión necesita señal: primero buscá conexión.</p>
        )}
        <button
          type="button"
          className="btn btn--primary session-notice__action"
          disabled={!online || busy}
          onClick={() => {
            setBusy(true);
            void resumeSession().finally(() => setBusy(false));
          }}
        >
          {busy ? "Retomando…" : resumeLabel(status.saved, silent)}
        </button>
      </div>
    </section>
  );
}

function resumeLabel(saved: boolean, silent: boolean): string {
  if (saved) {
    return "Retomar con mi PIN";
  }
  return silent ? "Retomar la sesión" : "Entrar con mi contraseña";
}
